(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.image-gallery__play');
    if (!button) return;

    const media = button.closest('.image-gallery__media');
    const video = media?.querySelector('video');
    if (!video) return;

    video.controls = true;
    media.classList.add('image-gallery__media--playing');
    video.play();
  });
  } catch(e) { console.error(e); }
})();

})();
